import React from 'react'
import Box, { BoxProps } from '../UI/Box'
import { Color } from '../../interfaces/designSystem'
import { IconType } from 'react-icons'
import Grid from './Grid'
import styled from 'styled-components'
import { usePathname, useRouter } from 'next/navigation'

interface Props extends BoxProps {
  icon: IconType
  children: any
  onClick?: () => void
  to?: string
  soon?: boolean
}

const Wrap = styled(Box)<{ active?: boolean; type?: string; disabled?: boolean }>`
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  position: relative;
  border: 0;
  background-color: ${({ active }) => (active ? Color.Blue_20 : 'transparent')};

  &:not(:disabled):hover {
    background-color: ${Color.Blue_20};
  }

  &:disabled {
    color: ${Color.Grey_80};
  }
`

const Soon = styled.span`
  display: block;
  padding: 2px;
  border-radius: 20px;
  font-size: 10px;
  position: absolute;
  background-color: ${Color.Grey_80};
  color: ${Color.White};
  top: 0;
  right: 0;
`

const MenuButton = ({ icon: Icon, children, onClick, to, soon, ...props }: Props) => {
  const router = useRouter()
  const pathname = usePathname()

  return (
    <Wrap
      use="button"
      type="button"
      borderRadius={7}
      p={10}
      active={pathname === to}
      onClick={() => {
        if (onClick) {
          onClick()
          return
        }

        if (to) {
          router.push(to)
        }
      }}
      disabled={soon}
      {...props}
    >
      <Grid gap={10} flow="column" alignItems="center" justifyContent="start">
        <Icon size={14} />
        <Box fontSize={14}>{children}</Box>
        {soon && <Soon>Soon</Soon>}
      </Grid>
    </Wrap>
  )
}

export default MenuButton
